import { faCircleInfo } from "@jewlr/pro-light-svg-icons/faCircleInfo"
// import { faTag } from "@jewlr/pro-regular-svg-icons/faTag"
import PropTypes from "prop-types"
import { connect, useSelector } from "react-redux"

import { openModal } from "components/modal"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Media from "components/ui/media"
import { IS_AU, IS_CA, isTestMode, IS_JEWLR } from "helpers/application"
import { to_currency } from "helpers/number"
import { cn } from "styles/utils"

import WizardPricingLoading from "./loaders/wizard-pricing-loading"
import Badge from "./wizard-header/badge"

const InternalProductPrice = ({
  miniview,
  onSale,
  prefStore,
  pricing,
  saleEnds,
  wizardLoading,
}) => {
  if (!prefStore || !Object.keys(pricing).length || wizardLoading) {
    return <WizardPricingLoading />
  } else if (pricing.price_to_display <= 0) {
    return ""
  }

  // const percentageSavings = (
  //   ((pricing.retail_price - pricing.price_to_display) * 100) /
  //   pricing.retail_price
  // ).toFixed(0)

  const holdbackExp = useSelector(
    (state) => state.experiment.holdback.variant_id
  )

  const currencyCode = IS_AU() ? "AU" : IS_CA() ? "C" : ""

  const handleHonestPricingClick = () => {
    openModal("#honest-pricing")
    if (!isTestMode) {
      dataLayer.push({
        event: "opened-pdp-honest-pricing-popup",
      })
    }
  }

  const globaleAttrs = {
    container: {},
    display: {},
    reg: {},
  }
  if (sl.config.global_e_pricing == "fixed") {
    if (onSale) {
      globaleAttrs.reg["data-fp"] =
        `"{${sl.config.site_country_for_analytics}": "${pricing.regular_pricing}"}`

      globaleAttrs.display["data-fp"] =
        `{"${sl.config.site_country_for_analytics}": "${pricing.price_to_display}"}`
    } else {
      globaleAttrs.display["data-fp"] =
        `{"${sl.config.site_country_for_analytics}": "${pricing.regular_pricing}"}`
    }
  } else {
    globaleAttrs.container["data-ge-product-container"] = true
    if (onSale) {
      globaleAttrs.reg["data-ge-list-price"] = true
      globaleAttrs.display["data-ge-sale-price"] = true
    } else {
      globaleAttrs.display["data-ge-price"] = true
    }
  }
  return (
    <div className="tablet:mt-0 mt-8">
      <div className="flex items-center" {...globaleAttrs.container}>
        {onSale && (
          <p
            className={cn(
              "text-grey-65 leading-34",
              holdbackExp === 0 ? "text-14 mr-10" : "mr-4",
              miniview ? "text-18" : "text-24"
            )}
          >
            <strike {...globaleAttrs.reg}>
              {currencyCode}
              {to_currency(pricing.regular_pricing)}
            </strike>
          </p>
        )}
        <h2
          className={cn(
            "tablet:text-28 tablet:leading-34 font-bold",
            holdbackExp === 0
              ? "text-18 leading-22"
              : miniview
                ? "text-24 leading-28"
                : "text-34 leading-42",
            onSale ? "text-ruby" : "text-black"
          )}
          data-cy="product-item-price"
          data-ge-parentproduct-total-price
          {...globaleAttrs.display}
        >
          {currencyCode}
          {to_currency(pricing.price_to_display)}
        </h2>
        {onSale && (
          <Media
            className={cn(
              "flex items-center",
              holdbackExp === 0 ? "ml-10" : "ml-12"
            )}
            lessThan="tablet"
          >
            <Badge />
          </Media>
        )}
      </div>
      {IS_JEWLR() && (
        <div className="text-12 tablet:tracking-wide tablet:mt-0 mt-4 flex items-center leading-none -tracking-tight">
          {/* <p className="text-ruby tablet:font-medium font-semibold">
            SAVE {percentageSavings}%
          </p>
          <div
            className="tablet:bg-grey-35 tablet:mx-8 mx-4 bg-black"
            role="separator"
            style={{ height: "12px", width: "1px" }}
          /> */}
          <Button
            aria-label={`Compare to ${to_currency(
              pricing.retail_price
            )} Estimated Retail. Read more about our value pricing`}
            onClick={handleHonestPricingClick}
          >
            <p className="text-10 tablet:12px tablet:font-light tablet:tracking-wide tablet:leading-14 tablet:no-underline tablet:normal-case font-semibold uppercase leading-none -tracking-tight">
              Compare to {to_currency(pricing.retail_price)} Estimated Retail
            </p>
            <FontAwesomeIcon
              className="text-12 tablet:text-10 ml-4"
              icon={faCircleInfo}
            />
          </Button>
        </div>
      )}
      {new Date().setHours(0, 0, 0, 0) <=
        new Date(saleEnds).setHours(0, 0, 0, 0) && (
        <p className="text-grey-500 text-12 mt-4">Sale ends {saleEnds}</p>
      )}
    </div>
  )
}

InternalProductPrice.propTypes = {
  miniview: PropTypes.bool,
  onSale: PropTypes.bool,
  prefStore: PropTypes.bool,
  pricing: PropTypes.object,
  saleEnds: PropTypes.string,
  wizardLoading: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    onSale: state.choices.sku && !!state.choices.sku.sale_price,
    prefStore: state.wizardUI.prefStore,
    pricing: state.wizardUI.currentPricing,
    saleEnds: state.wizard.price_and_promo.sale_ends,
    wizardLoading: state.wizard.loading,
  }
}

const ProductPrice = connect(mapStateToProps)(InternalProductPrice)

export default ProductPrice
